<template>
  <a-table
    class="children-table sku-table-css"
    bordered
    size="small"
    :data-source="childItemList"
    :pagination="needPagination(childItemList, 10)"
    rowKey="id"
    :locale="{ emptyText: '暂无子商品' }"
    :customRow="customRow"
    @change="tableChange"
  >
    <a-table-column key="sort" data-index="sort" title="序号（字母+数字）" width="15%"></a-table-column>
    <a-table-column key="img_url" data-index="img_url" title="商品图片" width="15%">
      <template #default="{ record }">
        <img v-if="!record.isEdit && record.img_url" :src="record.img_url" class="good-img" @click="imagePreview" />
      </template>
    </a-table-column>
    <a-table-column key="name" data-index="name" title="子商品名字" width="20%"></a-table-column>
    <a-table-column key="remark_name" data-index="remark_name" title="备注名称" width="20%"></a-table-column>
    <a-table-column key="stocks" data-index="stocks" title="库存/预售库存（件）" width="20%">
      <template v-slot="{ record }">
        <div style="display: flex; align-items: center">
          <div style="flex: 1">
            {{ record.stocks }} /
            <span :style="record.presale_stocks > 0 ? 'color:red' : ''">{{ record.presale_stocks }}</span>
          </div>
          <a-button type="link" @click="setChildItemForm(record)">编辑</a-button>
          <a-button v-if="record.is_new || record.can_del_item == 1" type="link" danger @click="removeChildItem(record)">移除</a-button>
        </div>
      </template>
    </a-table-column>
    <template v-slot:footer>
      <div class="table-footer">
        <div class="add-btn" @click="setChildItemForm()">
          <ehf-icon icon="add-circle-line" style="line-height: 25px"></ehf-icon>
          <div style="line-height: 25px; margin-left: 5px">添加子商品</div>
        </div>
        <div class="add-btn" @click="setBatchImport()">
          <ehf-icon icon="add-circle-line" style="line-height: 25px"></ehf-icon>
          <div style="line-height: 25px; margin-left: 5px">批量新增</div>
        </div>
      </div>
    </template>
  </a-table>
  <!-- 新增/编辑子商品表单弹窗 -->
  <children-form
    ref="childrenFormRef"
    :getContainer="getContainer"
    :supplierList="supplierList"
    :unitList="unitList"
    @addSupplier="addSupplier"
    @addUnit="addUnit"
    @deleteUnit="deleteUnit"
    @save="saveChildrenItem"
  ></children-form>
  <!-- 批量导入子商品 -->
  <batch-import
    ref="batchImportRef"
    :getContainer="getContainer"
    :supplierList="supplierList"
    :unitList="unitList"
    @addSupplier="addSupplier"
    @addUnit="addUnit"
    @deleteUnit="deleteUnit"
    @save="saveBatchChildren"
  ></batch-import>

  <!-- 新增单位 -->
  <a-modal v-model:open="unitModal.show" title="新增单位" centered destroyOnClose :getContainer="getContainer">
    <a-form :model="unitModal" :labelCol="{ style: { width: '80px' } }" labelAlign="right" :wrapperCol="{ span: 18 }">
      <a-form-item>
        <template #label>
          <span style="color: red">*</span>
          <span>单位名称</span>
        </template>
        <a-input v-model:value="unitModal.name" placeholder="请输入单位名称" :maxlength="2" />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button type="primary" :loading="unitModal.loading" @click="confirmAddUnit">保存</a-button>
    </template>
  </a-modal>

  <!-- 新增供应商 -->
  <SupplierModalVue ref="supplierModal" :getContainer="getContainer" @save="getSupplierList" />

  <ehf-image-preview ref="imagePreviewRef" />
</template>

<script setup>
  import { ref, toRefs, nextTick, watch } from 'vue'
  import { deepClone, isNull } from '../../../utils'
  import { nanoid } from 'nanoid'
  import ChildrenForm from './ChildrenForm.vue'
  import BatchImport from './BatchImport.vue'
  import SupplierModalVue from '@/views/project/integralSeckill/manageGoods/components/SupplierManage/components/SupplierModal.vue'
  import useSupplier from '../composables/useSupplier'
  import useUnit from '../composables/useUnit'
  import { message } from 'ant-design-vue'

  const props = defineProps({
    getContainer: {
      type: Function,
      default: () => {
        return document.body
      },
    },
    subGoodList: {
      type: Array,
      default: () => {
        return []
      },
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      },
    },
  })
  const emit = defineEmits(['update:sub-good-list', 'update:data-list', 'del-subgoods'])
  const { getContainer, subGoodList, dataList } = toRefs(props)

  const childItemList = ref(props.subGoodList)
  const itemList = ref(props.dataList)
  const delSubgoodsIdStr = ref([])
  watch(subGoodList, (val) => (childItemList.value = val))
  watch(dataList, (val) => (itemList.value = val))
  watch(itemList, (val) => emit('update:data-list', val))

  watch(childItemList, (val) => {
    emit('update:sub-good-list', val)
  })

  // 弹窗，信息显示位置
  message.config({
    getContainer: getContainer.value,
  })
  watch(getContainer, (val) => {
    message.config({
      getContainer: val,
    })
  })

  // -----子商品相关-----
  const childrenFormRef = ref(null)
  const setChildItemForm = (item) => {
    if (supplierList.value.length === 0) {
      getSupplierList()
    }
    if (unitList.value.length === 0) {
      getUnitList()
    }
    let lastItem = null
    if (childItemList.value.length > 0) {
      lastItem = childItemList.value[childItemList.value.length - 1]
    }
    childrenFormRef.value.setChildItemForm(item, lastItem)
  }
  // 保存子商品
  const saveChildrenItem = (saveItem) => {
    if (saveItem.name.trim() === '') {
      message.error('请输入商品名称')
      return false
    } else {
      const findIndex = childItemList.value.findIndex((v) => v.name === saveItem.name.trim() && v.id !== saveItem.id)
      if (findIndex > -1) {
        message.error(`子商品【${saveItem.name}】已存在`)
        return false
      }
    }
    if (saveItem.remark_name.trim() !== '') {
      const findIndex = childItemList.value.findIndex((v) => v.remark_name === saveItem.remark_name.trim() && v.id !== saveItem.id)
      if (findIndex > -1) {
        message.error(`备注名称【${saveItem.remark_name}】已存在`)
        return false
      }
    }
    if (saveItem.sup_id === null) {
      message.error('请选择供应商')
      return false
    }
    if (saveItem.unit === null) {
      message.error('请选择单位')
      return false
    }
    if (saveItem.id === '' || saveItem.is_new) {
      if (saveItem.is_new) {
        childItemList.value.push(saveItem)
        return true
      }
      const item = {
        id: new Date().getTime(),
        is_new: true,
        name: saveItem.name, // 商品名称
        remark_name: saveItem.remark_name, //备注名称
        sort: saveItem.sort, // 序号
        weight: saveItem.weight, // 重量
        unit: saveItem.unit, // 单位
        sup_id: saveItem.sup_id, // 供应商
        product_code: saveItem.product_code, // 货号
        pack_size: saveItem.pack_size, // 规格
        img_url: saveItem.img_url, // 图片
        stocks: 0,
        presale_stocks: 0,
      }
      childItemList.value.push(item)
    } else {
      childItemList.value.some((v) => {
        if (v.id === saveItem.id) {
          v.name = saveItem.name // 商品名称
          v.remark_name = saveItem.remark_name //备注名称
          v.sort = saveItem.sort // 序号
          v.weight = saveItem.weight // 重量
          v.unit = saveItem.unit // 单位
          v.sup_id = saveItem.sup_id // 供应商
          v.product_code = saveItem.product_code // 货号
          v.pack_size = saveItem.pack_size // 规格
          v.img_url = saveItem.img_url // 图片
        }
      })
    }
    childrenFormRef.value.childrenFormModal.show = false
  }
  // 删除子商品
  const removeChildItem = (item) => {
    if (!item.is_new && item.can_del_item != 1) {
      return
    }
    const items = deepClone(itemList.value)
    itemList.value = []
    nextTick(() => {
      itemList.value = items.map((parent) => {
        if (!isNull(parent.subgoods_relation)) {
          parent.subgoods_relation = parent.subgoods_relation.map((child) => {
            if (child.subgoods_id == item.id) {
              child.subgoods_id = null
              child.nums = ''
              child.size_id = undefined
            }
            return child
          })
          let childDel = true
          parent.subgoods_relation.forEach((v) => {
            if (v.size_id || v.subgoods_id) {
              childDel = false
              return childDel
            }
          })
          if (childDel) {
            parent.subid = nanoid()
            parent.isAdd = true
            parent.pic = ''
            parent.name = ''
            parent.subgoods_relation = []
            parent.total_price = ''
            parent.integral = ''
            parent.price = ''
            parent.linkman = ''
            parent.phone_num = ''
            parent.address = ''
            parent.purchase_price = ''
            parent.code = ''
          }
        }
        return parent
      })
      if (item.can_del_item == 1) {
        delSubgoodsIdStr.value.push(item.id)
      }
      childItemList.value.splice(childItemList.value.indexOf(item), 1)
      emit('del-subgoods', delSubgoodsIdStr.value)
    })
  }

  // -----供应商相关-----
  const { supplierList, supplierModal, getSupplierList, addSupplier } = useSupplier()
  // -----单位相关-----
  const { unitList, unitModal, addUnit, confirmAddUnit, deleteUnit, getUnitList } = useUnit(getContainer)

  // -----批量导入-----
  const batchImportRef = ref(null)
  const setBatchImport = () => {
    if (supplierList.value.length === 0) {
      getSupplierList()
    }
    if (unitList.value.length === 0) {
      getUnitList()
    }
    batchImportRef.value.batchImport()
  }
  const saveBatchChildren = (list, sup_id, unit) => {
    let result = true
    list.some((item) => {
      item.sup_id = sup_id
      item.unit = unit
      result = saveChildrenItem(item)
      if (!result) {
        return true
      }
    })
    if (result) {
      batchImportRef.value.batchImportModal.show = false
    }
  }
  // -----行点击高亮-----
  const highlightId = ref('')
  const customRow = (record) => {
    return {
      class: {
        highlight: record.id == highlightId.value,
      },
      onClick: () => {
        highlightId.value = record.id
      },
    }
  }
  // -----分页-----
  const page = ref(1)
  const needPagination = (list, pageSize) => {
    if (list.length > pageSize) {
      return {
        pageSize,
        current: page.value,
      }
    } else {
      return false
    }
  }
  const tableChange = (pagination) => {
    page.value = pagination.current
  }
  // -----图片预览-----
  const imagePreviewRef = ref(null)
  const imagePreview = (e) => {
    imagePreviewRef.value.initPhotoSwipeFromDOM('.children-table .good-img', e.target, true)
  }
</script>

<style lang="scss" scoped>
  .children-table {
    margin-bottom: 10px;
    .good-img {
      width: 40px;
      height: 40px;
      cursor: pointer;
      object-fit: cover;
    }
  }
  .sku-table-css {
    .table-footer {
      display: flex;
    }
    .add-btn {
      flex: 1;
      padding: 8px;
      text-align: center;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      & + .add-btn {
        border-left: 1px solid #e0e0e0;
      }
    }
  }
</style>
